import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
    {
        id: "po-04-h1v3-01",
        name: "PO 01 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 44, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 269, y: 269, width: 490, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 766, y: 269, width: 219, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-02",
        name: "PO 02 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "2", x: 103, y: 110, width: 420, height: 674, rotation: 0, imageRotation: 0 },
            { id: "1", x: 729, y: 110, width: 420, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 456, width: 207, height: 328, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 456, width: 206, height: 328, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-03",
        name: "PO 03 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 555, height: 894, rotation: 0, imageRotation: 0 },
            { id: "2", x: 697, y: 89, width: 474, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 697, y: 434, width: 233, height: 370, rotation: 0, imageRotation: 0 },
            { id: "4", x: 938, y: 434, width: 233, height: 370, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-04",
        name: "PO 04 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 42, y: 269, width: 492, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 269, width: 219, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-05",
        name: "PO 05 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 98, y: 123, width: 210, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 123, width: 210, height: 344, rotation: 0, imageRotation: 0 },
            { id: "3", x: 98, y: 474, width: 428, height: 296, rotation: 0, imageRotation: 0 },
            { id: "4", x: 708, y: 73, width: 461, height: 747, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-06",
        name: "PO 06 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 48, y: 305, width: 171, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 227, y: 305, width: 171, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 305, width: 171, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 674, y: 258, width: 529, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-07",
        name: "PO 07 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 40, y: 269, width: 216, height: 347, rotation: 0, imageRotation: 0 },
            { id: "2", x: 263, y: 153, width: 324, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 263, y: 392, width: 216, height: 347, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 0, width: 558, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-08",
        name: "PO 08 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 88, y: 202, width: 156, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 450, width: 156, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 251, y: 202, width: 315, height: 488, rotation: 0, imageRotation: 0 },
            { id: "4", x: 574, y: 202, width: 590, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-09",
        name: "PO 09 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 44, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 269, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 494, y: 269, width: 218, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 719, y: 269, width: 491, height: 354, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-10",
        name: "PO 10 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 61, y: 66, width: 945, height: 744, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1013, y: 66, width: 153, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1013, y: 316, width: 153, height: 243, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1013, y: 567, width: 153, height: 243, rotation: 0, imageRotation: 0 }
        ],
    }
];